import { estrelasDe, type Clube, type Posicao } from '../core';

/** As estrelas do craque (1 a 5 ★ dourados) para pôr ao lado do nome; vazio se o jogador não tem estrela. */
export function estrelasHtml(j: { overall: number }): string {
  const n = estrelasDe(j);
  return n > 0 ? ` <span class="estrelas e${n}" title="Craque: ${n} estrela${n > 1 ? 's' : ''}" aria-label="${n} estrela${n > 1 ? 's' : ''}">${'★'.repeat(n)}</span>` : '';
}

export const esc = (t: unknown): string =>
  String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] as string);

export function cor(c: string): string {
  return /^#[0-9a-fA-F]{3,8}$/.test(c) ? c : '#888888';
}

/** Cor de texto (preto ou branco) que contrasta com o fundo. */
export function contraste(hex: string): string {
  const h = cor(hex).replace('#', '');
  const v = h.length === 3 ? h.split('').map((x) => x + x).join('') : h.slice(0, 6);
  const r = parseInt(v.slice(0, 2), 16);
  const g = parseInt(v.slice(2, 4), 16);
  const b = parseInt(v.slice(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? '#000000' : '#ffffff';
}

export const num = (n: number): string => n.toLocaleString('pt-BR');

/** "92 mil", "3,2M", "12M": formato curto das colunas Salário e Passe. */
export function dinheiroCurto(n: number): string {
  const a = Math.abs(n);
  const sinal = n < 0 ? '-' : '';
  if (a >= 1_000_000) {
    const m = a / 1_000_000;
    return `${sinal}${Number.isInteger(Math.round(m * 10) / 10) ? Math.round(m) : (Math.round(m * 10) / 10).toLocaleString('pt-BR')}M`;
  }
  if (a >= 1000) return `${sinal}${Math.round(a / 1000)} mil`;
  return `${sinal}${a}`;
}

/** "12 milhões 626 mil", como na barra lateral do original. */
export function dinheiroExtenso(n: number): string {
  const sinal = n < 0 ? '-' : '';
  const a = Math.abs(Math.round(n));
  const milhoes = Math.floor(a / 1_000_000);
  const mil = Math.floor((a % 1_000_000) / 1000);
  const partes: string[] = [];
  if (milhoes > 0) partes.push(`${milhoes} ${milhoes === 1 ? 'milhão' : 'milhões'}`);
  if (mil > 0) partes.push(`${mil} mil`);
  if (partes.length === 0) partes.push(String(a));
  return sinal + partes.join(' ');
}

export function dataBR(d: Date): string {
  const dd = String(d.getUTCDate()).padStart(2, '0');
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${d.getUTCFullYear()}`;
}

export const NOME_POSICAO: Record<Posicao, string> = { G: 'Goleiro', Z: 'Zagueiro', L: 'Lateral', M: 'Meia', A: 'Atacante' };
export const ORDEM_POS: Record<Posicao, number> = { G: 0, L: 1, Z: 2, M: 3, A: 4 };

/** Cor da idade na tabela: azul para jovens, vermelho para veteranos, como no original. */
export function classeIdade(idade: number): string {
  if (idade <= 28) return 'id-jovem';
  if (idade >= 33) return 'id-velho';
  return '';
}

export function ordinal(n: number): string {
  return `${n}º`;
}

export function ladoTexto(l: 'E' | 'D'): string {
  return l === 'E' ? 'Esquerdo' : 'Direito';
}

export function nomeDoClube(c: Clube): string {
  return c.nome;
}
